/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { NgModule, InjectionToken } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExtendzApiConfig } from './models';
export var EXT_API_CONFIG = new InjectionToken('extApi.config');
export function provideApiConfig(config) {
    return new ExtendzApiConfig(config);
}
var ExtendzApiModule = /** @class */ (function () {
    function ExtendzApiModule() {
    }
    ExtendzApiModule_1 = ExtendzApiModule;
    ExtendzApiModule.forRoot = function (config) {
        return {
            ngModule: ExtendzApiModule_1,
            providers: [
                {
                    provide: EXT_API_CONFIG,
                    useValue: config
                },
                {
                    provide: ExtendzApiConfig,
                    useFactory: provideApiConfig,
                    deps: [EXT_API_CONFIG]
                }
            ]
        };
    }; // forRoot()
    ExtendzApiModule = ExtendzApiModule_1 = tslib_1.__decorate([
        NgModule({
            imports: [CommonModule]
        })
    ], ExtendzApiModule);
    return ExtendzApiModule;
    var ExtendzApiModule_1;
}()); // class
export { ExtendzApiModule };
//# sourceMappingURL=extendz-api.module.js.map